import { render } from "./TableBatchForm.vue?vue&type=template&id=75c0e6b1&scoped=true"
import script from "./TableBatchForm.vue?vue&type=script&lang=js"
export * from "./TableBatchForm.vue?vue&type=script&lang=js"

import "./TableBatchForm.vue?vue&type=style&index=0&id=75c0e6b1&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75c0e6b1"]])

export default __exports__